import { api, sp } from "./_base";


export const getAlloyFortigateByConfig = async (configId, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-fortigate/`, { params: { alloy_config: configId, ...sp(schemaName) } });
    return response.data;
  } catch (error) {
    console.error("Error fetching Fortigate jobs:", error);
    throw error;
  }
};

export const getAlloyFortigateById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-fortigate/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching Fortigate job:", error);
    throw error;
  }
};

export const createAlloyFortigate = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alloy-fortigate/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating Fortigate job:", error);
    throw error;
  }
};

export const updateAlloyFortigate = async (id, data, schemaName = null) => {
  try {
    const response = await api.put(`/alloy-fortigate/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating Fortigate job:", error);
    throw error;
  }
};

export const deleteAlloyFortigate = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alloy-fortigate/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting Fortigate job:", error);
    throw error;
  }
};
